<template>
    <div>

    </div>
</template>

<script>

import moment from "moment";
export default {
    name:  "ListaInicio",
    props: [],
    components: {
    },
    data() {
        return {
           
        };
    },
    methods: {

    },

    created() {
       

    },
};

</script>
